module.exports = __webpack_public_path__ + "img/logo_setra_branco.c31bf64c.png";